<header class="header">
  <div class="header-mobile">
    <div class="header-logo">
      <div class="header-logo" (click)="logoEvent()">
        <img src="../../assets/images/Skip Full Logo - Transparent.png" alt="logo">
      </div>
    </div>
    <button class="btn" (click)="openMobileNav()"><i class="fa-solid fa-bars"></i>Menu</button>
  </div>
    <div class="header-inner" [ngClass]="{ 'show': isVisible, 'hide': !isVisible }">
      <div class="header-left">
        <div class="header-navigation">
          @if (!inOnboarding && instanceLoaded) {
            <div class="menu-item" (click)="goToChat()">Chat</div>
            <div class="menu-item" (click)="goToReports()">Reports</div>
          }
          @if (!inSystemAdminMode) {
            <div class="menu-item" (click)="goToSettings()">Settings</div>
          }
        </div>
      </div>
      <div class="header-logo">
        <div class="header-logo" (click)="logoEvent()">
          <img src="../../assets/images/Skip Full Logo - Transparent.png" alt="logo">
        </div>
      </div>
      <div class="header-right">
         @if (!inSystemAdminMode) {
          <app-instance-dropdown></app-instance-dropdown>
        }
        <div class="mt-4 mt-lg-0">
          <app-auth-button></app-auth-button>
        </div>
      </div>
    </div>
</header>